module.exports = __webpack_public_path__ + "static/img/wc.52e0b02.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/rooms/wc.png
// module id = JkwS
// module chunks = 1